export const creditCard = {
  name: "credit-card" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25" fill="currentColor"><path fill-rule="evenodd" d="M1.6 6a.9.9 0 0 1 .9-.9h19a.9.9 0 0 1 .9.9v12a.9.9 0 0 1-.9.9h-19a.9.9 0 0 1-.9-.9V6Zm1.8.9v1.7h17.2V6.9H3.4Zm17.2 3.5H3.4v6.7h17.2v-6.7ZM5.1 13a.9.9 0 0 1 .9-.9h6a.9.9 0 0 1 0 1.8H6a.9.9 0 0 1-.9-.9Z" clip-rule="evenodd"/></svg>`,
  keywords: ["credit-card"],
  category: "finance" as const,
};
